import { Component, OnInit, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { User as Graph_User } from '@microsoft/microsoft-graph-types';
import * as Constants from '@shared/_constants';
import _ from 'lodash-es';

// Models
import { StudyViewModel } from '../../viewmodel/study.viewmodel';
import { UserStudy } from '../../models/userStudy.model';
import { Role } from '../../models/role.model';

// Services
import { DialogService } from '../../services/dialog.service';
import { GraphService } from '../../services/graph.service';
import { LoggingService } from '../../services/logging.service';

// Constants
import { ConfirmationResult } from '../../shared/_constants';
import { RoleEnum } from '../_study_constants';

@Component({
  selector: 'app-studyaccessinfo',
  templateUrl: './studyAccessInfo.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class StudyAccessInfoComponent implements OnInit {
  @Input() studyVM: StudyViewModel = new StudyViewModel();

  preparerRoleId: number = RoleEnum.Preparer;
  // to show/hide add team member div
  addMemberShow = false;

  // required  to keep track of adding users dynamically.
  addedUserCount = 1;

  // for auto complete to hold entered value
  term: any;
  // for auto complete to hold list of graph users
  users: Graph_User[];

  currentUser: Graph_User;
  preparerRole = RoleEnum[this.preparerRoleId];
  validationMessage = '';
  userExistMessage = '';

  roles: Role[] = [];

  constructor(private dialogService: DialogService, private logger: LoggingService, private graphService: GraphService) {}

  ngOnInit() {
    // fetch roles except Preparer
    this.roles = this.studyVM.roles.filter((item) => item.roleId !== RoleEnum.Preparer);
    // get current user with Preparer role and added into UserList to display data
    this.graphService.getCurrentUser().then((u) => {
      this.currentUser = u;
      if (
        (!this.studyVM.study.studyId || this.studyVM.study.studyId === 0) &&
        _.filter(this.studyVM.userList, function (o) {
          return o.user.activeDirectoryId === u.id;
        }).length === 0
      ) {
        const userStudy = this.getUserStudy(this.currentUser, RoleEnum.Preparer);
        this.studyVM.userList.push(userStudy);
      } else {
        this.addedUserCount = this.studyVM.userList.length + 1;
      }
    });
  }

  IsValidTeamComposition(): boolean {
    const membersCount = _.filter(this.studyVM.userList, 'isActive').length;

    // 1st check: Team member list cannot be empty
    if (membersCount < 2) {
      this.validationMessage = 'Team must have at least 2 members.';
      return false;
    }

    // 2nd Check: At least 1 preparer should present
    // (Temporary check once logged in user get this check will no longer required.)
    if (membersCount > 0) {
      if (
        _.filter(this.studyVM.userList, function (u) {
          return u.roleId === RoleEnum.Preparer;
        }).length < 1
      ) {
        this.validationMessage = 'Please add one preparer.';
        return false;
      }
    }

    return true;
  }

  private filterUsers(event) {
    this.validationMessage = '';

    const query = event.query;
    this.graphService.findUsers(query).then((users) => {
      this.users = users;
    });
  }

  private getEmailAddress(graphUser: Graph_User) {
    return typeof graphUser.mail !== 'undefined' && graphUser.mail ? graphUser.mail : graphUser.userPrincipalName;
  }

  private getUserStudy(graphUser: Graph_User, roleId?: number): UserStudy {
    const userStudy = new UserStudy();
    userStudy.roleId = roleId;
    userStudy.user.activeDirectoryId = graphUser.id;
    userStudy.user.emailAddress = this.getEmailAddress(graphUser);
    userStudy.user.officeLocation = graphUser.officeLocation;
    userStudy.user.preferredName = graphUser.displayName; // displayName
    userStudy.isActive = true;

    userStudy.user.firstName = graphUser.givenName;
    userStudy.user.lastName = graphUser.surname;
    userStudy.user.userPrincipalName = graphUser.userPrincipalName;
    // userStudy.user.samAccount = userStudy.user.samAccount;
    userStudy.user.CountryName = graphUser.country;

    // below property is not used to save data in DB.
    userStudy.rowId = this.addedUserCount;
    this.addedUserCount += 1;

    this.logger.info(this.constructor.name, 'getUserStudy', `userStudy=[${JSON.stringify(userStudy)}]`);
    return userStudy;
  }

  private selectedItem($event) {
    this.userExistMessage = '';

    // get item which represent GraphUser class
    const user = $event as Graph_User;

    const userExists = _.findIndex(this.studyVM.userList, function (u) {
      return u.user.activeDirectoryId === user.id && u.isActive === true;
    });

    if (userExists === -1) {
      // Set user data into User Study as this data will be pushed to userlist.
      const userStudy = this.getUserStudy(user, RoleEnum.Both);
      this.studyVM.userList.push(userStudy);

      // clear auto complete input control
      this.term = '';

      // hide add member section
      this.addMemberShow = false;
    } else {
      this.userExistMessage = 'User already exists in list';
    }
  }

  private async removeSelectedItem(item: UserStudy) {
    const confirmationResult = await this.dialogService.confirm('Please Confirm', Constants.ConfirmationMessage.RemoveUser, 'Yes', 'No');
    if (confirmationResult === ConfirmationResult.yes) {
      _.remove(this.studyVM.userList, function (n) {
        return n.user.activeDirectoryId === item.user.activeDirectoryId;
      });
    }
  }

  clearTextbox() {
    this.userExistMessage = '';
  }
}
